import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/index';

export interface LoaderState {
    show: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();
  constructor() { }
  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }
}
